import { useState } from "react";
import { FiFilePlus, FiFileText, FiTrash2 } from "react-icons/fi";
import { Container } from "./style";

type Props = {
    nameId: string,
    label: string,
    logoUrl?: string,
    changeLogoFile?: (value: any) => void
}

export const UploadPdf = ({ label, changeLogoFile, logoUrl, nameId }: Props): JSX.Element => {
    const [fileName, setFileName] = useState<string | undefined>(undefined);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.files?.[0];

        if (!selected) {
            setFileName(undefined);
            changeLogoFile?.(undefined);
            return;
        }

        if (selected.type !== 'application/pdf' && !selected.name.toLowerCase().endsWith('.pdf')) {
            setFileName(undefined);
            changeLogoFile?.(undefined);
            e.target.value = '';
            return;
        }

        setFileName(selected.name);

        const reader = new FileReader();
        reader.onload = () => {
            changeLogoFile?.(reader.result);
        };
        reader.readAsDataURL(selected);
    };

    const deletePicture = (): void => {
        setFileName(undefined);
        changeLogoFile?.(undefined);

        const input = document.getElementById(nameId) as HTMLInputElement | null;
        if (input) input.value = '';
    }

    const hasFile = Boolean(logoUrl || fileName);

    return (
        <Container>
            <div>{label}</div>

            <div className="previewProfilePic">
                {hasFile && (
                    <button type="button" className="trash" onClick={deletePicture} aria-label="Remover PDF">
                        <FiTrash2 size={16} />
                    </button>
                )}
                <div className={`pdf-preview ${hasFile ? 'has-file' : ''}`}>
                    <FiFileText size={36} />
                </div>
                <div className="text">{fileName || (typeof logoUrl === 'string' && logoUrl.includes('uploads') ? logoUrl.split('/').pop() : '')}</div>
            </div>

            <div className="register_profile_image">
                <label htmlFor={nameId} className="btn radius-100">
                    <FiFilePlus className="download-icon" size={16} color="#FFFFFF" />
                    <span>Adicionar</span>
                </label>
                <input id={nameId} type="file" style={{ visibility: "hidden" }} accept="application/pdf,.pdf" onChange={handleChange} />
            </div>
        </Container>
    )
}
